import * as React from 'react';

import {
    Heading,
    Stack,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    RadioGroup,
    Radio,
    Text,
    SimpleGrid,
    NumberInputField,
    Box,
    Card,
    CardHeader,
    CardBody,
    NumberInput,
    Flex,
    Button,
    useToast,
    IconButton,
    Divider,
    AbsoluteCenter,
    SkeletonText,
    Spinner,
    AlertDialog,
    useDisclosure,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Link,
    VStack,
    Checkbox

} from "@chakra-ui/react";
import { HiOutlineUserMinus } from "react-icons/hi2";
import { HiOutlineUserPlus } from "react-icons/hi2";

import {
    getGuestResponse,
    sendGuestResponse,
    getGuestConfirmedAddtlGuest,
    sendAddtlGuestConfirmation
} from "../../service/api/event";

import Entourage from "../entourage/entourage"
import QRCode from 'react-qr-code';
import { useLocation } from 'react-router-dom';

const emailValidationMessage = (value) => {
    const email = (value || '').trim();
    if (!email) {
        return 'Please fill in your email.';
    }
    if (email.length > 254 || email.includes(' ')) {
        return 'Enter a valid email address, like name@example.com.';
    }
    const at = email.indexOf('@');
    if (at <= 0 || at !== email.lastIndexOf('@')) {
        return 'Enter a valid email address, like name@example.com.';
    }
    const local = email.slice(0, at);
    const labels = email.slice(at + 1).split('.');
    const localPattern = /^[A-Za-z0-9](?:[A-Za-z0-9._%+-]{0,62}[A-Za-z0-9])?$/;
    const labelPattern = /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/;
    const localIsValid = localPattern.test(local);
    const domainIsValid = labels.length >= 2 && labels.every((label) => labelPattern.test(label));
    const tldIsValid = /^[A-Za-z]{2,63}$/.test(labels[labels.length - 1] || '');
    if (!localIsValid || !domainIsValid || !tldIsValid) {
        return 'Enter a valid email address, like name@example.com.';
    }
    return '';
};


function ResponseForm({ firstName, lastName, allowedAddtlGuest, inviteCode, inviteId }) {

    const [formFirstName, setFormFirstName] = React.useState('');
    const [formLastName, setFormLastName] = React.useState('');
    const [formEmail, setFormEmail] = React.useState('');
    const [emailError, setEmailError] = React.useState('');
    const [formResponse, setFormResponse] = React.useState('');
    const [formAddtlGuests, setformAddtlGuests] = React.useState(0);
    const [allocatedAddtlGuest, setAllocatedAddtlGuest] = React.useState([]);
    const [responseExist, setResponseExist] = React.useState(null);

    const [confirmedAddtlGuests, setConfirmedAddtlGuests] = React.useState([]);
    const [selectedGuests, setSelectedGuests] = React.useState([]); // MUST start as array
    const [selectedGuestsNames, setSelectedGuestsNames] = React.useState([]); // MUST start as array

    const [pageLoad, setPageLoad] = React.useState(true);
    const [submitLoad, setSubmitLoad] = React.useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [formInitialized, setFormInitialized] = React.useState(false);


    const [countdownToast, setCountdownToast] = React.useState(false);
    const location = useLocation();
    const currentURL = `${window.location.protocol}//${window.location.host}${location.pathname}${location.search}${location.hash}`

    const toast = useToast();

    const handleIncrement = () => {
        setformAddtlGuests((prev) => Math.min(prev + 1, allocatedAddtlGuest));
    };

    const handleDecrement = () => {
        setformAddtlGuests((prev) => Math.max(prev - 1, 0)); // Prevents negative values
    };

    const fetchExistingResp = async () => {
        const today = new Date();
        const rsvpEndData = new Date(today.getFullYear(), 9, 24); // November is month 10 in JavaScript Date (0-indexed)
        const weddingDay = new Date(today.getFullYear(), 11, 5); // November is month 10 in JavaScript Date (0-indexed)
        const daysUntilRsvpEnd = Math.ceil((rsvpEndData - today) / (1000 * 60 * 60 * 24));
        const daysUntilWedding = Math.ceil((weddingDay - today) / (1000 * 60 * 60 * 24));
        try {
            const response = await getGuestResponse(inviteCode)
            const confirmedAddtlGuestsResponse = await getGuestConfirmedAddtlGuest(inviteCode)


            if (response.status === 204) {
                setResponseExist(false)
            } else if (response.status === 200) {
                setResponseExist(response.data[0])


            } else {
                setResponseExist("Error")
            }
            if (response.data) {
                if (response.data[0].confirmed_guests != 0) {
                    console.log(",.,.,.,.")
                    console.log(response.data[0])
                    setConfirmedAddtlGuests(response.data[0].confirmed_guests)
                }
            }


            // Code to execute after the async call
            setPageLoad(false);
            if (response.status === 200) {
                if (response.data[0].response === "Yes") {
                    setCountdownToast(true);
                    toast({
                        title: `💒 👰‍♀️💍🤵‍♂️ 💐`,
                        description: `${daysUntilWedding} day${daysUntilWedding !== 1 ? 's' : ''} until November 14!`,
                        status: 'info',
                        duration: 8000,
                        isClosable: true,
                    });
                }
            }
            else {
                setCountdownToast(true);
                toast({
                    title: `Deadline of RSVP is on October 14, 2026`,
                    description: `${daysUntilRsvpEnd} day${daysUntilRsvpEnd !== 1 ? 's' : ''} until October 14.`,
                    status: 'info',
                    duration: 8000,
                    isClosable: true,
                });
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const sendResponseAPi = async (data) => {
        try {
            setSubmitLoad(true);
            const responseApiResponse = await sendGuestResponse(inviteCode, data)
            if (responseApiResponse.status !== 201) {
                setSubmitLoad(false);
                toast({
                    title: "We are having difficulties.",
                    description: "Please contact the couple.",
                    status: "error",
                    duration: 15000,
                    isClosable: true,
                })
                setResponseExist("Error")
            } else {

                setSubmitLoad(false);
                setResponseExist(responseApiResponse.data)
                setInitialForm();
            }
            fetchExistingResp()

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const sendConfAddtlGuest = async (data) => {
        try {
            setSubmitLoad(true);
            const responseApiResponse = await sendAddtlGuestConfirmation(inviteCode, data)
            if (responseApiResponse.status !== 201) {
                setSubmitLoad(false);
                toast({
                    title: "We are having difficulties.",
                    description: "Please contact the couple.",
                    status: "error",
                    duration: 15000,
                    isClosable: true,
                })
                setResponseExist("Error")
            } else {
                setSubmitLoad(false);
                setResponseExist(responseApiResponse.data)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const setInitialForm = () => {
        const today = new Date();
        const rsvpEndData = new Date(today.getFullYear(), 10, 8); // November is month 10 in JavaScript Date (0-indexed)
        const weddingDay = new Date(today.getFullYear(), 11, 18); // November is month 10 in JavaScript Date (0-indexed)
        const daysUntilRsvpEnd = Math.ceil((rsvpEndData - today) / (1000 * 60 * 60 * 24));
        const daysUntilWedding = Math.ceil((weddingDay - today) / (1000 * 60 * 60 * 24));
        // This code will run only once when the component mounts
        if (!formInitialized) {
            if (allowedAddtlGuest !== null) {
                setAllocatedAddtlGuest(allowedAddtlGuest);
                console.log("***")
                console.log(allowedAddtlGuest)
            }
            if (firstName !== null) {
                setFormFirstName(firstName);
            }
            if (lastName !== null) {
                setFormLastName(lastName);
            }
            if (inviteCode !== null) {
                fetchExistingResp();
            }
            if (countdownToast && responseExist !== null) {
                if (responseExist.response === "Yes") {
                    setCountdownToast(true);
                    toast({
                        title: `Countdown`,
                        description: `${daysUntilWedding} day${daysUntilWedding !== 1 ? 's' : ''} until November 14.`,
                        status: 'info',
                        duration: 5000,
                        isClosable: true,
                    });
                } else {
                    setCountdownToast(true);
                    toast({
                        title: `Deadline of RSVP is on October 14, 2026`,
                        description: `${daysUntilRsvpEnd} day${daysUntilRsvpEnd !== 1 ? 's' : ''} until October 14.`,
                        status: 'info',
                        duration: 5000,
                        isClosable: true,
                    });
                }
            }
        }

        setFormInitialized(true);
    }

    React.useEffect(() => {
        setInitialForm();

    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        let hasValidationError = false;


        // Validate inputs
        if (!formLastName) {
            hasValidationError = true
            toast({
                title: "Missing Last Name.",
                description: "Please fill in Last Name.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
        }
        const emailMessage = emailValidationMessage(formEmail);
        if (emailMessage) {
            hasValidationError = true
            setEmailError(emailMessage);
            toast({
                title: emailMessage.startsWith('Please fill') ? "Missing Email." : "Invalid email.",
                description: emailMessage,
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
        } else {
            setEmailError('');
        }
        if (!formFirstName) {
            hasValidationError = true
            toast({
                title: "Missing First Name.",
                description: "Please fill in First Name.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
        }
        if (!formResponse) {
            hasValidationError = true
            toast({
                title: "You did not select a response.",
                description: "Please select a response.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
        }
        if (formAddtlGuests > allocatedAddtlGuest) {
            hasValidationError = true
            toast({
                title: "Not enough guests allocated.",
                description: "You have exceeded the allocated number of additonal Guests",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
        }

        if (hasValidationError) {
            return;
        }
        onOpen();


    }

    const handleSendReponse = (event) => {
        event.preventDefault();

        const rsvpResponsePayload = {
            confirmed_guests: selectedGuests,
            response: formResponse,
            invite_rsvp_id: inviteId,
            first_name: formFirstName,
            last_name: formLastName,
            email: formEmail.trim()
        }

        sendResponseAPi(rsvpResponsePayload)


        // onClose()
    }

    const handleChange = (name) => {
        setSelectedGuests((prev) =>
            prev.includes(name.id)
                ? prev.filter((g) => g !== name.id) // uncheck
                : [...prev, name.id]                 // check
        );
        setSelectedGuestsNames((prevName) =>
            prevName.includes(name.fullname)
                ? prevName.filter((g) => g !== name.fullname) // uncheck
                : [...prevName, name.fullname]                 // check
        );
    };

    if (pageLoad) {
        return (
            <Card
                shadow='xl'
                margin={8}
                padding={4}>
                <Box padding='6' boxShadow='lg' bg='white'>

                    <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
                </Box>
            </Card>)

    }
    else if (responseExist && !pageLoad) {
        return (
            <div>
                <Card
                    backgroundColor="#FEEFEC"
                    shadow='xl'
                    margin={8}
                    padding={4}>
                    <Heading style={{ fontFamily: "'Satisfy', cursive", }}>
                        Hi {formFirstName},
                    </Heading>
                    <CardBody >
                        {responseExist.response === "Yes" ? (
                            <Stack>
                                <Text fontSize='2xl' style={{ fontFamily: "'Satisfy', cursive", }}>
                                    Thank you for confirming your attendance!
                                    We’re excited to have you join us at our wedding.
                                    Get ready for a wonderful time filled with great company and memorable moments.
                                </Text>
                                {confirmedAddtlGuests.length > 0 ? (
                                    <div>
                                        <Text fontSize='2xl' style={{ fontFamily: "'Satisfy', cursive", }}>
                                            You are comming together with:

                                        </Text>
                                        <VStack>
                                            {confirmedAddtlGuests.map((name) => (
                                                <Text fontSize='2xl' style={{ fontFamily: "'Satisfy', cursive", }} as="b">
                                                    {name.fullname}
                                                </Text>
                                            ))}
                                        </VStack>


                                        <Text fontSize='2xl' style={{ fontFamily: "'Satisfy', cursive", }}>
                                            <br />
                                            Feel free to share this link to your companions.

                                            {/* <Stack direction="column"> */}
                                            <Stack>
                                                <Link fontSize='xl' color='teal' href={currentURL}>{currentURL}</Link>
                                                <QRCode size={110} value={currentURL}></QRCode>
                                            </Stack>

                                            {/* </Stack> */}
                                        </Text>
                                    </div>


                                ) : (
                                    <Text fontSize='2xl' style={{ fontFamily: "'Satisfy', cursive", }}>

                                    </Text>
                                )}

                                <Text textColor='#af2d0f' fontSize='3xl' style={{ fontFamily: "'Satisfy', cursive", }}>
                                    Looking forward to seeing you on our wedding day!
                                </Text>
                                <Stack paddingTop={7}>
                                    <Text fontSize='2x;' style={{ fontFamily: "'Satisfy', cursive", }}>
                                        Love,
                                    </Text>
                                    <Text fontSize='2x;' style={{ fontFamily: "'Satisfy', cursive", }}>
                                        Jed & Tonet
                                    </Text>
                                </Stack>
                            </Stack>

                        ) : (
                            <Stack>


                                <Text fontSize='2xl' style={{ fontFamily: "'Satisfy', cursive", }}>
                                    {console.log(responseExist)}
                                    We’re sorry to hear you won’t be able to join us at our wedding. Your presence will be missed, but we hope to see you at future gatherings.
                                </Text>
                                <Text fontSize='3xl' textColor='#af2d0f' style={{ fontFamily: "'Satisfy', cursive", }}>
                                    Wishing you all the best!
                                </Text>
                                <Text fontSize='xl' style={{ fontFamily: "'Satisfy', cursive", }}>
                                    Incase you change your mind let us know.
                                </Text>
                                <Stack paddingTop={7}>
                                    <Text fontSize='2x;' style={{ fontFamily: "'Satisfy', cursive", }}>
                                        Love,
                                    </Text>
                                    <Text fontSize='2x;' style={{ fontFamily: "'Satisfy', cursive", }}>
                                        Jed & Tonet
                                    </Text>
                                </Stack>
                            </Stack>
                        )}
                    </CardBody>
                </Card>

            </div>
        )
    } else {
        return (
            <div>
                <Card
                    shadow='xl'
                    margin={2}>
                    <CardHeader>

                        {{ firstName } ? (
                            <Heading>
                                {firstName}'s RSVP
                            </Heading>

                        ) : (
                            <Heading>
                                RSVP
                            </Heading>
                        )}
                        <Text fontSize='md'>
                            Please send your RSVP on or before October 14, 2026.
                        </Text>
                    </CardHeader>
                    <CardBody as="form" noValidate onSubmit={handleSubmit}>
                        <FormControl >
                            <Stack spacing={4}>
                                <FormControl>

                                    <FormLabel>First Name</FormLabel>
                                    <Input
                                        onChange={
                                            (e) => {
                                                setFormFirstName(e.target.value)
                                            }}
                                        value={formFirstName}
                                        type="
                                    text" placeholder='Enter your first name.' />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>Last Name</FormLabel>
                                    <Input
                                        onChange={
                                            (e) => {
                                                setFormLastName(e.target.value);
                                            }}
                                        value={formLastName} type="text" placeholder='Enter your last name.' />
                                </FormControl>
                                <FormControl isInvalid={!!emailError}>
                                    <FormLabel>Email</FormLabel>
                                    <Input
                                        onChange={
                                            (e) => {
                                                const nextEmail = e.target.value;
                                                setFormEmail(nextEmail);
                                                if (emailError) {
                                                    setEmailError(emailValidationMessage(nextEmail));
                                                }
                                            }}
                                        onBlur={() => setEmailError(emailValidationMessage(formEmail))}
                                        value={formEmail}
                                        type="email"
                                        inputMode="email"
                                        autoComplete="email"
                                        placeholder='Enter your email address.' />
                                    <FormErrorMessage>{emailError}</FormErrorMessage>
                                </FormControl>
                                <Stack>
                                    <RadioGroup onChange={
                                        (e) => {
                                            setFormResponse(e)
                                        }}
                                        value={formResponse} >
                                        <Stack direction='column'>
                                            <Radio value='Yes'>I will joyfully attend</Radio>
                                            <Radio value='No'>I'm sorry I can't make it</Radio>
                                        </Stack>
                                    </RadioGroup>
                                </Stack>
                                { }
                                <SimpleGrid>
                                    {allowedAddtlGuest && formResponse === 'Yes' ? (
                                        <div>
                                            <Box position='relative' padding='10'>
                                                <Divider />
                                                <AbsoluteCenter bg='white' px='4'>
                                                    Accompanying guests
                                                </AbsoluteCenter>
                                            </Box>
                                            <Flex>
                                                <Stack direction='column'>
                                                    {/* <Text fontSize="sm">We reserved {allocatedAddtlGuest} additional seats for you.</Text> */}
                                                    <Text>I'm coming with</Text>
                                                    <VStack align="start" spacing={3}>
                                                        {allocatedAddtlGuest.map((name) => (
                                                            <Checkbox
                                                                key={name.id}  // ensure unique key
                                                                id={name.id}
                                                                isChecked={selectedGuests.includes(name.id)}
                                                                onChange={() => handleChange(name)}
                                                            >
                                                                {name.fullname}
                                                            </Checkbox>
                                                        ))}
                                                    </VStack>
                                                </Stack>
                                            </Flex>
                                        </div>
                                    ) : (<div className="noAddtl"></div>)}
                                </SimpleGrid>
                                {submitLoad ? (
                                    <Button isDisabled>
                                        <Spinner size="sm" mr={2} />
                                        Sending RSVP
                                    </Button>
                                ) : (
                                    <Button type="submit" colorScheme="teal" margin={3}>Submit my RSVP</Button>

                                )}
                            </Stack>
                        </FormControl>
                    </CardBody>
                </Card>
                <AlertDialog
                    isOpen={isOpen}
                    onClose={onClose}

                >
                    <AlertDialogOverlay >
                        <AlertDialogContent margin={3}>
                            <AlertDialogHeader>
                                Please confirm
                            </AlertDialogHeader>

                            <AlertDialogBody>
                                You can only send RSVP once.
                                Are you sure you want to submit?
                                <Box>
                                    <Stack direction='column'>
                                        <Stack direction='row'>
                                            <Text>
                                                Your reponse is:
                                            </Text>
                                            {formResponse === "Yes" ? (
                                                <Text as="b">
                                                    You will attend
                                                </Text>

                                            ) : (
                                                <Text as="b">
                                                    You can't make it :(
                                                </Text>
                                            )}

                                        </Stack>
                                        {selectedGuestsNames.length > 0 ? (
                                            <>
                                                {formAddtlGuests < allocatedAddtlGuest ? (
                                                    <div></div>

                                                ) : (
                                                    <Stack direction="row">
                                                        <Text>Accompanying guests:  </Text>

                                                        <Stack direction="column">
                                                            {selectedGuestsNames.map((name, index) => (
                                                                <Text as="b">
                                                                    {name}
                                                                </Text>
                                                            ))}
                                                        </Stack>

                                                    </Stack>
                                                )}
                                            </>

                                        ) : (
                                            <div className="empty"></div>

                                        )}

                                    </Stack>
                                </Box>
                            </AlertDialogBody>
                            <AlertDialogFooter>
                                <Button onClick={onClose}>
                                    Cancel
                                </Button>
                                <Button
                                    colorScheme="red"
                                    onClick={handleSendReponse}
                                    ml={3}>
                                    Submit
                                </Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>

                    </AlertDialogOverlay>
                </AlertDialog>
            </div >

        )
    }
}






export default ResponseForm;